var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzureCloudBrandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 979.5 170.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #035bda;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#Degradado_sin_nombre_3);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #0078d4;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#Degradado_sin_nombre_4);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#Degradado_sin_nombre_2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    "data-name": "Degradado sin nombre 4",
    x1: -658.6,
    y1: 71.2,
    x2: -688.7,
    y2: 160.1,
    gradientTransform: "translate(1111.8 -87.5) scale(1.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    "data-name": "Degradado sin nombre 2",
    x1: -649.2,
    y1: 112.6,
    x2: -656.2,
    y2: 115,
    gradientTransform: "translate(1111.8 -87.5) scale(1.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#000",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    "data-name": "Degradado sin nombre 3",
    x1: -652.8,
    y1: 68.6,
    x2: -619.8,
    y2: 156.5,
    gradientTransform: "translate(1111.8 -87.5) scale(1.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ccbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892df"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.3,13.1h45.3l-47,139.2c-1,2.9-3.7,4.9-6.8,4.9H22.5c-4,0-7.2-3.2-7.2-7.2,0-.8.1-1.6.4-2.3L59.4,18c1-2.9,3.7-4.9,6.8-4.9h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132,106.5H60.3c-1.8,0-3.3,1.5-3.3,3.3,0,.9.4,1.8,1.1,2.4l46.1,43c1.3,1.3,3.1,1.9,4.9,1.9h40.6l-17.7-50.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.3,13.1c-3.1,0-5.9,2-6.9,5L15.7,147.6c-1.3,3.7.6,7.9,4.3,9.2.8.3,1.6.4,2.4.4h36.1c2.7-.5,5-2.4,5.9-5l8.7-25.7,31.1,29c1.3,1.1,2.9,1.7,4.6,1.7h40.5l-17.8-50.7h-51.8S111.7,13.1,111.7,13.1h-45.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.1,18c-1-2.9-3.7-4.9-6.8-4.9h-50.4c3.1,0,5.8,2,6.8,4.9l43.8,129.7c1.3,3.8-.8,7.9-4.5,9.1-.7.3-1.5.4-2.3.4h50.4c4,0,7.2-3.2,7.2-7.2,0-.8-.1-1.6-.4-2.3L124.1,18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.1,124.8h-12.6v-49.1c0-4.9.1-9.7.5-14.6-.4,2.4-1.1,4.8-2.2,7l-23,57.1h-8.8l-23.1-56.6-2.2-7.6c.5,3.2.5,8.1.5,15.1v49.2h-12.1V49.3h18.1l20.3,50.7,3.3,8.6c.8-3.1,1.9-6.2,3.3-9.2l20.8-50.7h17.6l-.5,76ZM292.6,59c-2.1.1-4.1-.7-5.5-2.2-1.5-1.2-2.3-3-2.2-4.9-.2-1.9.6-3.8,2.2-4.9,1.6-1.3,3.5-2,5.5-2.2,2.1-.1,4.1.7,5.5,2.2,1.5,1.2,2.3,3,2.2,4.9.2,1.9-.6,3.8-2.2,4.9-1.4,1.5-3.4,2.3-5.5,2.2ZM298.7,124.8h-12.6v-54.5h12.6v54.5ZM355.2,122.7c-4.4,2.7-9.9,3.8-15.9,3.8s-14.8-2.7-19.8-7.6-7.6-11.3-7.6-19.4,2.7-16.2,8.2-21.6,12.6-8.1,21.9-8.1c4.5,0,9,.9,13.2,2.7v11.3c-3.5-2.6-7.7-4.1-12.1-4.3-5.5,0-9.9,1.6-13.2,5.4-3.4,3.8-5.1,8.8-4.9,14,0,5.4,1.6,10.2,4.9,13.5,3.4,3.2,7.9,5,12.6,4.9,4.7,0,9.1-1.8,12.6-4.9v10.3h0ZM399.6,82.2c-2-1.2-4.3-1.7-6.6-1.6-3.8,0-6.6,1.6-9.3,4.9-2.7,3.2-3.8,7.6-3.8,13.5v25.9h-12.6v-54.5h12.6v11.3c1-3.5,2.9-6.6,5.5-9.2,2.4-2.2,5.5-3.3,8.8-3.2,1.7,0,3.4.3,4.9,1.1l.5,11.9ZM433.1,126.5c-8.8,0-15.4-2.7-20.3-7.6-5-4.9-7.6-11.9-7.6-19.9s2.7-16.2,8.2-21.6c5.5-5.4,12.6-7.6,21.4-7.6s15.4,2.7,20.3,7.6,7.1,11.8,7.1,21c.2,7.7-2.5,15.3-7.6,21-6.1,4.7-13.7,7.2-21.5,7.1h0ZM433.6,79c-4.9,0-8.8,1.6-11.5,4.9-2.7,3.2-4.4,8.1-4.4,14s1.6,10.2,4.4,13.5c2.7,3.2,6.6,4.9,11.5,4.9s8.8-1.6,11.5-4.9c2.7-3.2,3.8-7.6,3.8-14s-1.1-10.8-3.8-14c-3.1-2.9-7.3-4.5-11.5-4.3h0ZM470.9,123.2v-11.4c4.9,3.2,9.9,5.4,15.4,5.4s11.5-2.2,11.5-6.5c-.1-1.1-.5-2.3-1.1-3.2-.7-1-1.6-1.8-2.7-2.2-1.2-.6-2.5-1.2-3.8-1.6l-4.9-1.6c-2.1-.8-4.1-1.7-6-2.7-1.6-.9-3-2-4.4-3.2-1.2-1.2-2.2-2.7-2.7-4.3-.7-1.7-1-3.5-1.1-5.4,0-2.4.5-4.8,1.6-7,1.1-2.1,2.8-3.8,4.9-4.9,2.2-1.6,4.4-2.2,7.1-3.2,2.7-.6,5.5-1,8.2-1.1,4.7-.2,9.3.6,13.7,2.2v10.8c-3.9-2.6-8.5-4-13.2-3.8-1.5-.1-3,0-4.4.5-1.1.5-2.2.5-3.3,1.1-1,.4-1.8,1.2-2.2,2.2-.4.8-.6,1.8-.5,2.7,0,1.1,0,2.2.5,3.2.4,1,1.2,1.7,2.2,2.2,1.2.6,2.5,1.2,3.8,1.6,1.6.5,2.7,1.1,4.9,1.6,2.1,1.1,4.3,2,6.6,2.7,2.2.5,3.3,2.2,4.9,3.2,1.2,1.3,2.3,2.8,3.3,4.3.7,1.9,1,3.9,1.1,5.9,0,2.7-.5,5.4-2.2,7-1.2,2-2.9,3.7-4.9,4.9-2.5,1.3-5,2.4-7.6,3.2-8.3,2.1-17.1,1.1-24.7-2.7h0ZM547.2,126.5c-8.8,0-15.4-2.7-20.3-7.6-5-4.9-7.6-11.9-7.6-19.9s2.7-16.2,8.2-21.6c5.5-5.4,12.6-7.6,21.4-7.6s15.4,2.7,20.3,7.6c5,4.9,7.1,11.9,7.1,21,.2,7.7-2.5,15.3-7.6,21-6.2,4.7-13.8,7.1-21.6,7h0ZM547.8,79c-4.9,0-8.8,1.6-11.5,4.9-2.7,3.2-4.4,8.1-4.4,14s1.6,10.2,4.4,13.5c2.7,3.2,6.6,4.9,11.5,4.9s8.8-1.6,11.5-4.9c2.7-3.2,3.8-7.6,3.8-14s-1.1-10.8-3.8-14c-3.1-3-7.3-4.6-11.5-4.4h0ZM619.6,54.7c-1.8-1.1-3.9-1.7-6-1.6-6,0-9.3,3.2-9.3,10.2v7.6h12.6v9.7h-12.6v44.8h-12.6v-44.8h-9.3v-9.7h9.3v-8.6c0-5.9,1.6-10.2,5.5-13.5,6.1-4.7,14.1-6.1,21.4-3.8v9.7h1.1ZM655.8,124.3c-2.2,1.1-5.5,1.6-9.9,1.6-11,0-15.9-4.9-15.9-15.1v-30.7h-9.3v-9.7h9.3v-12.4l12.6-3.2v16.2h13.2v9.7h-13.2v27c-.2,2.4.4,4.9,1.6,7,1.1,1.6,3.3,2.2,6,2.2,2,0,3.9-.6,5.5-1.7v9.2h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "800.3 76.2 770.7 115.5 800.3 115.5 800.3 125.2 753.1 125.2 753.1 120.5 783.8 80.5 756.4 80.5 756.4 70.8 800.8 70.8 800.8 76.2 800.3 76.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M859.5,125.3h-12.6v-8.6c-3.3,6.2-9.9,10-17,9.7-13.2,0-19.8-7.6-19.8-23.2v-32.4h12.6v31.3c0,9.7,3.8,14.6,11.5,14.6,3.5.1,6.9-1.2,9.3-3.8,2.5-3.1,3.8-6.9,3.8-10.8v-31.2h12.6l-.5,54.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M907.8,82.7c-2-1.2-4.3-1.7-6.6-1.6-3.8,0-6.6,1.6-9.3,4.9-2.7,3.2-3.8,7.6-3.8,13.5v25.9h-12.6v-54.5h12.6v11.3c1-3.5,2.9-6.6,5.5-9.2,2.4-2.1,5.5-3.3,8.7-3.2,1.7,0,3.4.3,4.9,1.1l.6,11.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M720.6,49.2h-14.2l-29.1,76.1h14.3l6.6-19.4h30.7l7.1,19.4h14.3l-29.7-76.1ZM702,95.6l10.4-30.2c.5-1.6.8-3.2,1.1-4.9.2,1.6.6,3.3,1.1,4.9l11,30.2h-23.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M964.2,96.7c0-8.6-1.6-15.1-6-19.9-4.4-4.9-9.9-7-17.6-7-7.3-.2-14.3,2.7-19.2,8.1-5.1,5.6-7.9,12.9-7.6,20.5,0,9.2,2.2,16.2,7.1,21,5.1,5.1,12,7.9,19.2,7.6,8.2,0,14.8-1.6,19.8-4.9v-9.7c-4.7,3.6-10.6,5.5-16.5,5.4-5.5,0-9.9-1.6-12.6-4.3-3.3-2.7-4.9-7-4.9-11.9h37.8l.5-4.9ZM925.9,92.9c.6-4.3,1.7-7.6,4.4-10.2,2.4-2.6,5.8-4,9.3-3.8,3.4-.2,6.6,1.2,8.8,3.8,2.2,2.2,3.3,5.9,3.3,10.2h-25.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureCloudBrandLogo);
export default __webpack_public_path__ + "static/media/azure-cloud-brand-logo.09397fa68e7515057d31382bede494a3.svg";
export { ForwardRef as ReactComponent };